const getObjectKeys = <T extends Record<any, any>, K extends keyof T>(arg: T): K[] => {
  return Object.keys(arg) as K[];
};

export { getObjectKeys };
